import { AppSwitcher } from '@teamworksdev/vuetify';
import { computed } from 'vue';
import { useGmApi } from './useGmApi';
import { handleError } from '@/utils/errorHandling';
import { useUserStore } from '@/stores/userStore';

export function useAppSwitcher() {
  const GmApi = useGmApi();
  const userStore = useUserStore();

  const appSwitcher = computed(() => new AppSwitcher(
    AppSwitcher.slugs.GM,
    () => GmApi.getOutgoingAxleToken()
      .then(({ token }) => token)
      .catch((e) => {
        handleError(e);
        return '';
      }),
    userStore.axleProfile?.appTargetUrls ?? [],
    userStore.axleProfile?.loginAccess ?? {},
    !!userStore.impersonator,
  ));

  return appSwitcher;
}
